
import React from "react";
import { isToday, isPast, startOfDay } from "date-fns";
import { cn } from "@/lib/utils";

interface TimeGridProps {
  timeSlots: string[];
  weekDays: Date[];
  handleDateClick: (date: Date) => void;
  settings: any;
}

export const TimeGrid: React.FC<TimeGridProps> = ({ 
  timeSlots, 
  weekDays, 
  handleDateClick,
}) => {
  if (!timeSlots || !weekDays) return null;
  
  return (
    <>
      {timeSlots.map(time => (
        <React.Fragment key={time}>
          <div className="relative h-[60px] border-b border-gray-300 dark:border-gray-700 z-10 sticky left-0 bg-gray-50 dark:bg-gray-800">
            <span className="absolute -top-3 text-sm text-muted-foreground dark:text-gray-400 pl-2">
              {time}
            </span>
          </div>
          {weekDays.map(day => {
            const today = isToday(day);
            const past = isPast(startOfDay(day)) && !today;
            
            return (
              <div 
                key={`${day.toISOString()}-${time}`} 
                className={cn(
                  "relative h-[60px] border-b border-gray-300 dark:border-gray-700",
                  past 
                    ? "bg-gray-200/70 dark:bg-gray-700/60 cursor-not-allowed" 
                    : "hover:bg-muted/50 dark:hover:bg-gray-700/30 cursor-pointer",
                  today && "bg-primary/5 dark:bg-primary/10"
                )}
                onClick={() => {
                  if (past) return;
                  const [hours, minutes] = time.split(':').map(Number);
                  const clickedDate = new Date(day);
                  clickedDate.setHours(hours || 0, minutes || 0);
                  handleDateClick(clickedDate);
                }} 
              />
            );
          })}
        </React.Fragment>
      ))}
    </>
  );
};
